// Sprint 8 — Perfil público
import { Link2 } from "lucide-react";
import type { CSSProperties, ReactNode } from "react";

type Props = {
  url: string;
  size?: number;
  className?: string;
  style?: CSSProperties;
};

function hostnameKey(raw: string): string {
  try {
    const u = new URL(raw.trim().includes("://") ? raw.trim() : `https://${raw.trim()}`);
    return u.hostname.replace(/^www\./i, "").toLowerCase();
  } catch {
    return "";
  }
}

/** Rutas tomadas de lucide-icons (ISC); TikTok y desconocidos → Link2. */
function IconSvg({
  children,
  size,
  className,
  style,
}: {
  children: ReactNode;
  size: number;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
      aria-hidden
    >
      {children}
    </svg>
  );
}

function pickKind(host: string): "instagram" | "facebook" | "linkedin" | "twitter" | "youtube" | "github" | "tiktok" | "link" {
  if (host.includes("instagram.")) return "instagram";
  if (host.includes("facebook.") || host === "fb.com" || host.endsWith(".fb.com")) return "facebook";
  if (host.includes("linkedin.")) return "linkedin";
  if (host.includes("twitter.") || host === "x.com" || host.endsWith(".x.com")) return "twitter";
  if (host.includes("youtube.") || host === "youtu.be") return "youtube";
  if (host.includes("github.")) return "github";
  if (host.includes("tiktok.")) return "tiktok";
  return "link";
}

export function SocialLinkIcon({ url, size = 20, className, style }: Props) {
  const kind = pickKind(hostnameKey(url));
  if (kind === "tiktok" || kind === "link") {
    return <Link2 size={size} className={className} style={style} aria-hidden />;
  }
  if (kind === "instagram") {
    return (
      <IconSvg size={size} className={className} style={style}>
        <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
        <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
      </IconSvg>
    );
  }
  if (kind === "facebook") {
    return (
      <IconSvg size={size} className={className} style={style}>
        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
      </IconSvg>
    );
  }
  if (kind === "linkedin") {
    return (
      <IconSvg size={size} className={className} style={style}>
        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
        <rect width="4" height="12" x="2" y="9" />
        <circle cx="4" cy="4" r="2" />
      </IconSvg>
    );
  }
  if (kind === "twitter") {
    return (
      <IconSvg size={size} className={className} style={style}>
        <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z" />
      </IconSvg>
    );
  }
  if (kind === "youtube") {
    return (
      <IconSvg size={size} className={className} style={style}>
        <path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17" />
        <path d="m10 15 5-3-5-3z" />
      </IconSvg>
    );
  }
  return (
    <IconSvg size={size} className={className} style={style}>
      <path d="M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4" />
      <path d="M9 18c-4.51 2-5-2-7-2" />
    </IconSvg>
  );
}
